<p class="modal-title flex items-center gap-8">
  <app-game-icon game="Case Battles"></app-game-icon>
  Case Battle Case Selection
</p>
<div class="filters flex w-full items-center">
  <app-search-input [(query)]="search" placeholder="Search for cases" />
  <app-select [title]="'Sort by'" [selected]="sort()" [options]="sortOptions" />
</div>
<div class="divider horizontal w-full divider-between-header-and-content"></div>
<div class="cases">
  <div class="cases-list">
    @for (caseItem of filtered(); track $index; let i = $index) {
    <app-cb-case
      animate.enter="animate-skins-enter"
      [style.--stagger-delay]="i * 30 + 'ms'"
      [caseItem]="caseItem"
      [balance]="sessionService.balanceType()"
      (handleIncreaseQuantity)="handleIncreaseQuantity(caseItem)"
      (handleDecreaseQuantity)="handleDecreaseQuantity(caseItem)"
      (handleRemoveCase)="handleDecreaseQuantity(caseItem, true)"
    ></app-cb-case>
    } @empty { @if (casesService.casesList().length !== 0) {
    <div class="w-full flex flex-col gap-4 items-center absolute-center">
      <span class="typography-title">No cases found, try clearing search</span>
      <button
        class="button button--style-primary h-32 padding-x-12 rounded-4"
        (click)="search.set('')"
      >
        Clear search
      </button>
    </div>
    } }
  </div>
</div>

<div class="summary">
  <div class="summary--container">
    <div class="summary--content">
      <svg-icon
        class="bg"
        src="assets/images/ui-effects/background-vector.svg"
      />
      <div class="summary--selected-items">
        <div class="summary--selected-items__cost">
          <app-balance-icon
            [balance]="sessionService.balanceType()"
          ></app-balance-icon>
          {{ caseBattlesCreateService.selectedCasesPrice() | number : "1.2-2" }}
        </div>
        <span class="summary--selected-items__text typography-info"
          >{{ caseBattlesCreateService.selectedCases().length }} cases
          selected</span
        >
      </div>
      <div class="divider vertical h-full"></div>
      <button
        class="button button--style-primary padding-x-12 clear-store"
        style="--button-height: 32px"
        (click)="handleResetSelectedCases()"
      >
        <svg-icon
          class="panel-icon flex items-center justify-center s-14"
          src="assets/icons/ui/refresh.svg"
          [class.icon-rotating]="isShowRefreshAnimation()"
        ></svg-icon>
        Clear selected cases
      </button>

      <button
        class="summary--action-button button button--style-yellow padding-x-12"
        style="--button-height: 38px"
        (click)="modalService.close()"
      >
        <app-game-icon game="Case Battles"></app-game-icon>
        Back to Battle Create
      </button>
    </div>
  </div>
</div>
